export default __webpack_public_path__ + "static/WAA_BrandVideo_Animation-ef29d29afcd4aee385c829feb9568fe3.gif";